module.exports = __webpack_public_path__ + "static/img/ourAppImg1.14b0bf08.png";